<div class="pto-project-cards-main-container">
  <div class="pto-project-cards-filters-container">
    <span class="projects-title">Projects</span>
    <p-button styleClass="sort-by-btn" (click)="op.toggle($event)">
      <img alt="logo" src="../../../../../assets/icons/projects-overview/sort_by_icon.svg"/>
      <span>Sort by</span>
    </p-button>
    <p-overlayPanel #op styleClass="pto-sort-by-overlay">
      <ng-template pTemplate>
        <div class="filter-option" *ngFor="let radio of radioButtons">
          <label class="d-flex gap-2 mb-0">
            <p-radioButton
              (onClick)="setFilterByScore()"
              [name]="'sort-by'" id="{{radio.id}}"
              [value]="radio"
              [(ngModel)]="selectedRadioButton">
            </p-radioButton>
            <span>{{radio.label}}</span>
          </label>
        </div>
      </ng-template>
    </p-overlayPanel>
  </div>
  <div class="pto-cards-container">
    <div class="pto-card" *ngFor="let card of projectCards">
      <div class="pto-card-labels">
        <div class="project-type-container">
          <span>{{card.project.projectType | uppercase}}</span>
        </div>
      </div>
      <span class="project-name">{{card.project.name}}</span>
      <div class="project-health-container">
        <div class="project-health-title-and-rate">
          <span class="health-title mb-auto">Project Health</span>
          <div class="health-rate-container">
            Good rate
          </div>
        </div>
        <app-gauge-display *ngIf="card.score"
          [value]="card.score"
          [width]="125"
          [height]="100"
          [trend]="null"
          [colorStart]="color"
          [colorEnd]="color"
          [isOnTeamCodex]="false"
          [backgroundColor]="'rgba(255, 255, 255, 1)'">
        </app-gauge-display>
      </div>
      <div class="pto-card-manager-container">
        <span>Project Manager:</span>
        <div class="d-flex align-items-center gap-2">
          <img class="manager-avatar"
               [src]="(card.project.leader.user?.avatar !== null && card.project.leader.user.avatar?.path !== null) ?
                       baseUrl + card.project.leader.user.avatar?.path: '../../../assets/svg/user-icon.svg'"
               alt="icon">
          <span class="manager-name">
            {{card.project.leader.user.detail.displayName ?
              card.project.leader.user.detail.displayName :
              (card.project.leader.user.detail.firstname ||
                card.project.leader.user.detail.lastname) ?
                card.project.leader.user.detail.firstname+' '+card.project.leader.user.detail.lastname :
                card.project.leader.user.email}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
